import { Toolbar } from '@kerfjs/ui/toolbar';
import type { SafeHtml } from 'kerfjs';

import { PrimaryAddControl } from '../demand-editor/components/primary-add-control.js';

/** Secondary header for Settings › Members: the admin's "New Member…" invitation action (HS2-FJ9J2K). */
export function MembersHeader(): SafeHtml {
  return <Toolbar label="Member Actions" trailing={<PrimaryAddControl action="member-new" label="New Member…" />} />;
}
